exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account_box[data-v-5fb4ac4d]{padding:20px 20px 40px 20px}.title[data-v-5fb4ac4d]{font-size:20px;font-weight:600}.search_criteria[data-v-5fb4ac4d]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-top:10px}.search_criteria>div[data-v-5fb4ac4d]{margin:0 5px;width:180px}.w100[data-v-5fb4ac4d]{width:100%}", ""]);

// exports
